import { render, staticRenderFns } from "./Ict.vue?vue&type=template&id=dfc53fb6&scoped=true&"
import script from "./Ict.vue?vue&type=script&lang=js&"
export * from "./Ict.vue?vue&type=script&lang=js&"
import style0 from "./Ict.vue?vue&type=style&index=0&id=dfc53fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc53fb6",
  null
  
)

component.options.__file = "Ict.vue"
export default component.exports